import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { Button, Card } from 'components/gsys-ui'
import ModalContainer from 'components/ModalContainer'

const AlertModal = NiceModal.create(({ title, message }) => {
    const modal = useModal()

    return (
        <ModalContainer>
            <Card className="p-4 w-[320px] space-y-4">
                <div className="text-lg font-bold">{title}</div>
                <div>{message}</div>
                <div className="flex justify-end">
                    <Button onClick={modal.remove}>OK</Button>
                </div>
            </Card>
        </ModalContainer>
    )
})

export default AlertModal
